<div class="w-full  flex flex-col mb-[10px]">
    <div class="rounded-xl overflow-hidden bg-white flex-shrink-0 mb-2">
        <z-tab-group 
            zAlignTabs="start" 
            [zFullWidth]="false"
            (zOnTabChange)="onTabChange($event)">
            @for(tab of innerTabs; track tab.route) {
                <z-tab [label]="tab.label | transloco">
                    <ng-container></ng-container>
                </z-tab>
            }
        </z-tab-group>
    </div>

    <router-outlet></router-outlet>
</div>
